import { View, Text, StyleSheet, TouchableOpacity, Alert } from 'react-native'
import React, { useState } from 'react'
import Avatar from './Avatar'
import moment from 'moment';
import { theme } from '../constants/theme';
import { hp } from '../helpers/common';
import {Delete, MessageCircle} from '../../assets/icons';
import { useNavigation } from '@react-navigation/native';

const CommentItem = ({
    item,
    canDelete=false,
    onDelete=()=>{},
    onReply=()=>{},
    highlight = false,
    showReplies=true,
    isReply=false,
    replies=[],
    onToggleReplies=()=>{},
    showRepliesButton=true,
}) => {
    const navigation = useNavigation();
    const [showRepliesList, setShowRepliesList] = useState(false);

    const createdAt = moment(item?.created_at).format('MMM D');
    const replyCount = replies?.length || 0;

    const handleDelete = ()=>{
        Alert.alert('Confirm', 'Are you sure you want to do this?', [
            {
              text: 'Cancel',
              onPress: () => {},
              style: 'cancel',
            },
            {
                text: 'Delete', 
                onPress: () => onDelete(item),
                style: 'destructive'
            },
        ]);
    }

    const navigateToUserProfile = () => {
        if (item?.user?.id) {
            navigation.navigate('profile', { userId: item.user.id });
        }
    };

    const handleReply = () => {
        onReply(item);
    };

    const toggleReplies = () => {
        setShowRepliesList(!showRepliesList);
        onToggleReplies(item, !showRepliesList);
    };

  return (
    <View style={[styles.container, isReply && styles.replyContainer]}>
        <TouchableOpacity onPress={navigateToUserProfile} activeOpacity={0.7}>
            <Avatar
                uri={item?.user?.image}
                size={isReply ? hp(3.5) : hp(4)}
            />
        </TouchableOpacity>
        <View style={[styles.content, highlight && styles.highlight, isReply && styles.replyContent]}>
            <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                <View style={styles.nameContainer}>
                    <Text style={[styles.text, isReply && styles.replyText]}>{item?.user?.name}</Text>
                    <Text style={isReply && styles.replyText}>•</Text>
                    <Text style={[styles.text, {color: theme.colors.textLight}, isReply && styles.replyText]}>{createdAt}</Text>
                </View>
                {
                    canDelete && (
                        <TouchableOpacity onPress={handleDelete}>
                            <Delete size={20} color={theme.colors.rose} />
                        </TouchableOpacity>
                    )
                }
            </View>
            
            <Text style={[styles.text, {fontWeight: 'normal'}, isReply && styles.replyText]}>
                {item.body || item.text}
            </Text>

            {/* Reply button and count */}
            {!isReply && showRepliesButton && (
                <View style={styles.replyActions}>
                    <TouchableOpacity onPress={handleReply} style={styles.replyButton}>
                        <MessageCircle size={16} color={theme.colors.primary} />
                        <Text style={styles.replyButtonText}>Reply</Text>
                    </TouchableOpacity>
                    
                    {replyCount > 0 && (
                        <TouchableOpacity onPress={toggleReplies} style={styles.repliesToggle}>
                            <Text style={styles.repliesToggleText}>
                                {showRepliesList ? 'Hide' : 'View'} {replyCount} {replyCount === 1 ? 'reply' : 'replies'}
                            </Text>
                        </TouchableOpacity>
                    )}
                </View>
            )}

            {/* Replies list */}
            {!isReply && showReplies && showRepliesList && replies.length > 0 && (
                <View style={styles.repliesContainer}>
                    {replies.map((reply) => (
                        <CommentItem
                            key={reply.id}
                            item={reply}
                            canDelete={canDelete}
                            onDelete={onDelete}
                            isReply={true}
                        />
                    ))}
                </View>
            )}
        </View>
    </View>
  )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        gap: 7,
    },
    replyContainer: {
        marginLeft: hp(2),
        marginTop: 8,
    },
    content: {
        backgroundColor: 'rgba(0,0,0,0.06)',
        flex: 1,
        gap: 5,
        paddingHorizontal: 14,
        paddingVertical: 10,
        borderRadius: theme.radius.md,
        borderCurve: 'continuous',
    },
    replyContent: {
        backgroundColor: 'rgba(0,0,0,0.03)',
        borderLeftWidth: 2,
        borderLeftColor: theme.colors.primary,
    },
    highlight: {
        borderWidth: 0.2,
        backgroundColor: 'white',
        borderColor: theme.colors.dark,
        shadowColor: theme.colors.dark,
        shadowOffset: {width: 0, height: 0},
        shadowOpacity: 0.3,
        shadowRadius: 8,
        elevation: 5
    },
    nameContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 3,
    },
    text: {
        fontSize: hp(1.6),
        fontWeight: theme.fonts.medium,
        color: theme.colors.textDark,
    },
    replyText: {
        fontSize: hp(1.4),
    },
    replyActions: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 15,
        marginTop: 8,
    },
    replyButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderRadius: theme.radius.sm,
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
    replyButtonText: {
        fontSize: hp(1.4),
        color: theme.colors.primary,
        fontWeight: theme.fonts.medium,
    },
    repliesToggle: {
        paddingVertical: 4,
    },
    repliesToggleText: {
        fontSize: hp(1.3),
        color: theme.colors.textLight,
        fontWeight: theme.fonts.medium,
    },
    repliesContainer: {
        marginTop: 8,
        gap: 8,
    }
})

export default CommentItem;